export enum ImageShootType {
    Hollow = 'hollow',
    ModelNoFace = 'modelNoFace',
    Model = 'model',
    Folded = 'folded',
    Flat = 'flat',
    Detail = 'detail',
    Unknown = 'unknown'
}
